import React, { useId } from 'react';
import { AttentionIcon } from 'shared/components/ui/ProjectIcons';
import { inputClasses } from 'styles/tailwindClassnames';

type EarthRangerSiteInputProps = {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
};

const EarthRangerSiteInput = ({
  value,
  onChange,
  error,
}: EarthRangerSiteInputProps) => {
  const suffixId = useId();
  return (
    <div>
      <div className="flex flex-row items-center">
        <input
          id="base_url"
          aria-describedby={suffixId}
          placeholder=""
          className={`${error ? inputClasses.error : inputClasses.standard} min-w-0 flex-1`}
          value={value}
          onChange={onChange}
        />
        <span id={suffixId} className="ml-2 shrink-0 text-ui-text-primary-text">
          .pamdas.org
        </span>
      </div>
      {error && (
        <div className="flex flex-row items-center rounded py-1 text-ui-status-error-destructive">
          <AttentionIcon />
          <p className="ml-1 mt-0.5">{error}</p>
        </div>
      )}
    </div>
  );
};

export default EarthRangerSiteInput;
